const messages = {
    en: {
        role: {
            permissions: {
                PRODUCT_SHOW: "View Product",
                PRODUCT_UPDATE: "Modify Product",
                PRODUCT_CREATE: "Create Product",
                PRODUCT_DELETE: "Delete Product",
                PRODUCTCATEGORY_SHOW: "View Product Category",
                PRODUCTCATEGORY_UPDATE: "Modify Product Category",
                PRODUCTCATEGORY_CREATE: "Create Product Category",
                PRODUCTCATEGORY_DELETE: "Delete Product Category",
                INGREDIENT_SHOW: "View Ingredient",
                INGREDIENT_UPDATE: "Modify Ingredient",
                INGREDIENT_CREATE: "Create Ingredient",
                INGREDIENT_DELETE: "Delete Ingredient",
                ORDER_SHOW: "View Order",
                ORDER_UPDATE: "Modify Order",
                ORDER_CREATE: "Create Order",
                ORDER_DELETE: "Delete Order",
                ORDER_SHOW_KITCHEN: "View Kitchen orders",
                ORDER_SHOW_OVEN: "View Oven orders",
                ORDER_SHOW_DELIVERY: "View Delivery orders",
                ORDER_SHOW_BAR: "View Bar orders",
                ORDER_SHOW_SALON: "View Salon orders",
                ORDER_SHOW_WAITER: "View Waiter orders",
                MY_DELIVERY_ORDERS: "View my delivery orders",
                ORDER_DISCOUNT: "Apply Order discount",
                ORDER_EXPORT: "Export Orders",
                BRANCH_SHOW: "View Branch",
                BRANCH_UPDATE: "Modify Branch",
                BRANCH_CREATE: "Create Branch",
                BRANCH_DELETE: "Delete Branch",
                STOCK_MENU: "Access Stock menu",
                STOCK_SHOW: "View Stock",
                STOCK_UPDATE: "Modify Stock",
                STOCK_CREATE: "Create Stock",
                STOCK_DELETE: "Delete Stock",
                STOCKTRANSACTION_SHOW: "View Stock Transaction",
                STOCKTRANSACTION_UPDATE: "Modify Stock Transaction",
                STOCKTRANSACTION_CREATE: "Create Stock Transaction",
                STOCKTRANSACTION_DELETE: "Delete Stock Transaction",
                STOCKTRANSACTION_REVERSE: "Reverse Stock Movement",
                STOCKDAILY_SHOW: "View Daily Stock",
                STOCKDAILY_UPDATE: "Modify Daily Stock",
                STOCKDAILY_CREATE: "Create Daily Stock",
                STOCKDAILY_DELETE: "Delete Daily Stock",
                ORDERSTATE_MENU: "Access Order State menu",
                ORDERSTATE_SHOW: "View Order State",
                ORDERSTATE_UPDATE: "Modify Order State",
                ORDERSTATE_CREATE: "Create Order State",
                ORDERSTATE_DELETE: "Delete Order State",
                DAILYBOX_MENU: "Access Daily Box menu",
                DAILYBOX_SHOW: "View Daily Box",
                DAILYBOX_UPDATE: "Modify Daily Box",
                DAILYBOX_CREATE: "Create Daily Box",
                DAILYBOX_DELETE: "Delete Daily Box",
                PROMO_MENU: "Access Promo menu",
                PROMO_SHOW: "View Promo",
                PROMO_UPDATE: "Modify Promo",
                PROMO_CREATE: "Create Promo",
                PROMO_DELETE: "Delete Promo",
                COUPON_MENU: "Access Coupon menu",
                COUPON_SHOW: "View Coupon",
                COUPON_UPDATE: "Modify Coupon",
                COUPON_CREATE: "Create Coupon",
                COUPON_DELETE: "Delete Coupon",
                SURVEYS_SHOW: "View Surveys",
                SURVEYS_UPDATE: "Modify Surveys",
                SURVEYS_CREATE: "Create Surveys",
                SURVEYS_DELETE: "Delete Surveys",
                SURVEYS_MANAGEMENT: "Manage Surveys",
                SURVEYS_RESPONSE_SHOW: "View Survey responses",
                SURVEY_RESPONSES_MANAGEMENT: "Manage Survey responses",
                SURVEY_VIEW_CONFIG_UPDATE: "Modify Survey view configuration",
                QUANTITY_SALE: "View quantity sales report",
                AMOUNT_SALE: "View amount sales report",
                REPORT_SALES: "View Sales report",
                REPORT_ORDER: "View Orders report",
                REPORT_MENU: "Access Reports menu",
                OPERATION_MENU: "Access Operations menu",
                MANAGE_MENU: "Access Management menu",
                SALON_MENU: "Access Salon menu"
            }
        }
    },
    es: {
        role: {
            permissions: {
                PRODUCT_SHOW: "Ver Producto",
                PRODUCT_UPDATE: "Modificar Producto",
                PRODUCT_CREATE: "Crear Producto",
                PRODUCT_DELETE: "Eliminar Producto",
                PRODUCTCATEGORY_SHOW: "Ver Categoría de Producto",
                PRODUCTCATEGORY_UPDATE: "Modificar Categoría de Producto",
                PRODUCTCATEGORY_CREATE: "Crear Categoría de Producto",
                PRODUCTCATEGORY_DELETE: "Eliminar Categoría de Producto",
                INGREDIENT_SHOW: "Ver Ingrediente",
                INGREDIENT_UPDATE: "Modificar Ingrediente",
                INGREDIENT_CREATE: "Crear Ingrediente",
                INGREDIENT_DELETE: "Eliminar Ingrediente",
                ORDER_SHOW: "Ver Pedido",
                ORDER_UPDATE: "Modificar Pedido",
                ORDER_CREATE: "Crear Pedido",
                ORDER_DELETE: "Eliminar Pedido",
                ORDER_SHOW_KITCHEN: "Ver pedidos de Cocina",
                ORDER_SHOW_OVEN: "Ver pedidos de Horno",
                ORDER_SHOW_DELIVERY: "Ver pedidos de Delivery",
                ORDER_SHOW_BAR: "Ver pedidos de Barra",
                ORDER_SHOW_SALON: "Ver pedidos de Salón",
                ORDER_SHOW_WAITER: "Ver pedidos de Mozo",
                MY_DELIVERY_ORDERS: "Ver mis pedidos de Delivery",
                ORDER_DISCOUNT: "Aplicar descuento en Pedido",
                ORDER_EXPORT: "Exportar Pedidos",
                BRANCH_SHOW: "Ver Sucursal",
                BRANCH_UPDATE: "Modificar Sucursal",
                BRANCH_CREATE: "Crear Sucursal",
                BRANCH_DELETE: "Eliminar Sucursal",
                STOCK_MENU: "Acceder al menú de Stock",
                STOCK_SHOW: "Ver Stock",
                STOCK_UPDATE: "Modificar Stock",
                STOCK_CREATE: "Crear Stock",
                STOCK_DELETE: "Eliminar Stock",
                STOCKTRANSACTION_SHOW: "Ver Movimiento de Stock",
                STOCKTRANSACTION_UPDATE: "Modificar Movimiento de Stock",
                STOCKTRANSACTION_CREATE: "Crear Movimiento de Stock",
                STOCKTRANSACTION_DELETE: "Eliminar Movimiento de Stock",
                STOCKTRANSACTION_REVERSE: "Revertir Movimiento de Stock",
                STOCKDAILY_SHOW: "Ver Stock Diario",
                STOCKDAILY_UPDATE: "Modificar Stock Diario",
                STOCKDAILY_CREATE: "Crear Stock Diario",
                STOCKDAILY_DELETE: "Eliminar Stock Diario",
                ORDERSTATE_MENU: "Acceder al menú de Estados de Pedido",
                ORDERSTATE_SHOW: "Ver Estado de Pedido",
                ORDERSTATE_UPDATE: "Modificar Estado de Pedido",
                ORDERSTATE_CREATE: "Crear Estado de Pedido",
                ORDERSTATE_DELETE: "Eliminar Estado de Pedido",
                DAILYBOX_MENU: "Acceder al menú de Caja Diaria",
                DAILYBOX_SHOW: "Ver Caja Diaria",
                DAILYBOX_UPDATE: "Modificar Caja Diaria",
                DAILYBOX_CREATE: "Crear Caja Diaria",
                DAILYBOX_DELETE: "Eliminar Caja Diaria",
                PROMO_MENU: "Acceder al menú de Promociones",
                PROMO_SHOW: "Ver Promoción",
                PROMO_UPDATE: "Modificar Promoción",
                PROMO_CREATE: "Crear Promoción",
                PROMO_DELETE: "Eliminar Promoción",
                COUPON_MENU: "Acceder al menú de Cupones",
                COUPON_SHOW: "Ver Cupón",
                COUPON_UPDATE: "Modificar Cupón",
                COUPON_CREATE: "Crear Cupón",
                COUPON_DELETE: "Eliminar Cupón",
                SURVEYS_SHOW: "Ver Encuestas",
                SURVEYS_UPDATE: "Modificar Encuestas",
                SURVEYS_CREATE: "Crear Encuestas",
                SURVEYS_DELETE: "Eliminar Encuestas",
                SURVEYS_MANAGEMENT: "Administrar Encuestas",
                SURVEYS_RESPONSE_SHOW: "Ver respuestas de Encuestas",
                SURVEY_RESPONSES_MANAGEMENT: "Administrar respuestas de Encuestas",
                SURVEY_VIEW_CONFIG_UPDATE: "Modificar configuración de vista de Encuestas",
                QUANTITY_SALE: "Ver reporte de ventas por cantidad",
                AMOUNT_SALE: "Ver reporte de ventas por importe",
                REPORT_SALES: "Ver reporte de ventas",
                REPORT_ORDER: "Ver reporte de pedidos",
                REPORT_MENU: "Acceder al menú de Reportes",
                OPERATION_MENU: "Acceder al menú de Operaciones",
                MANAGE_MENU: "Acceder al menú de Administración",
                SALON_MENU: "Acceder al menú de Salón"
            }
        }
    },
    pt: {
        role: {
            permissions: {
                PRODUCT_SHOW: "Ver Produto",
                PRODUCT_UPDATE: "Modificar Produto",
                PRODUCT_CREATE: "Criar Produto",
                PRODUCT_DELETE: "Eliminar Produto",
                PRODUCTCATEGORY_SHOW: "Ver Categoria de Produto",
                PRODUCTCATEGORY_UPDATE: "Modificar Categoria de Produto",
                PRODUCTCATEGORY_CREATE: "Criar Categoria de Produto",
                PRODUCTCATEGORY_DELETE: "Eliminar Categoria de Produto",
                INGREDIENT_SHOW: "Ver Ingrediente",
                INGREDIENT_UPDATE: "Modificar Ingrediente",
                INGREDIENT_CREATE: "Criar Ingrediente",
                INGREDIENT_DELETE: "Eliminar Ingrediente",
                ORDER_SHOW: "Ver Pedido",
                ORDER_UPDATE: "Modificar Pedido",
                ORDER_CREATE: "Criar Pedido",
                ORDER_DELETE: "Eliminar Pedido",
                ORDER_SHOW_KITCHEN: "Ver pedidos da Cozinha",
                ORDER_SHOW_OVEN: "Ver pedidos do Forno",
                ORDER_SHOW_DELIVERY: "Ver pedidos de Delivery",
                ORDER_SHOW_BAR: "Ver pedidos do Bar",
                ORDER_SHOW_SALON: "Ver pedidos do Salão",
                ORDER_SHOW_WAITER: "Ver pedidos do Garçom",
                MY_DELIVERY_ORDERS: "Ver meus pedidos de Delivery",
                ORDER_DISCOUNT: "Aplicar desconto no Pedido",
                ORDER_EXPORT: "Exportar Pedidos",
                BRANCH_SHOW: "Ver Filial",
                BRANCH_UPDATE: "Modificar Filial",
                BRANCH_CREATE: "Criar Filial",
                BRANCH_DELETE: "Eliminar Filial",
                STOCK_MENU: "Acessar menu de Estoque",
                STOCK_SHOW: "Ver Estoque",
                STOCK_UPDATE: "Modificar Estoque",
                STOCK_CREATE: "Criar Estoque",
                STOCK_DELETE: "Eliminar Estoque",
                STOCKTRANSACTION_SHOW: "Ver Movimentação de Estoque",
                STOCKTRANSACTION_UPDATE: "Modificar Movimentação de Estoque",
                STOCKTRANSACTION_CREATE: "Criar Movimentação de Estoque",
                STOCKTRANSACTION_DELETE: "Eliminar Movimentação de Estoque",
                STOCKTRANSACTION_REVERSE: "Reverter Movimentação de Estoque",
                STOCKDAILY_SHOW: "Ver Estoque Diário",
                STOCKDAILY_UPDATE: "Modificar Estoque Diário",
                STOCKDAILY_CREATE: "Criar Estoque Diário",
                STOCKDAILY_DELETE: "Eliminar Estoque Diário",
                ORDERSTATE_MENU: "Acessar menu de Estados do Pedido",
                ORDERSTATE_SHOW: "Ver Estado do Pedido",
                ORDERSTATE_UPDATE: "Modificar Estado do Pedido",
                ORDERSTATE_CREATE: "Criar Estado do Pedido",
                ORDERSTATE_DELETE: "Eliminar Estado do Pedido",
                DAILYBOX_MENU: "Acessar menu de Caixa Diário",
                DAILYBOX_SHOW: "Ver Caixa Diário",
                DAILYBOX_UPDATE: "Modificar Caixa Diário",
                DAILYBOX_CREATE: "Criar Caixa Diário",
                DAILYBOX_DELETE: "Eliminar Caixa Diário",
                PROMO_MENU: "Acessar menu de Promoções",
                PROMO_SHOW: "Ver Promoção",
                PROMO_UPDATE: "Modificar Promoção",
                PROMO_CREATE: "Criar Promoção",
                PROMO_DELETE: "Eliminar Promoção",
                COUPON_MENU: "Acessar menu de Cupons",
                COUPON_SHOW: "Ver Cupom",
                COUPON_UPDATE: "Modificar Cupom",
                COUPON_CREATE: "Criar Cupom",
                COUPON_DELETE: "Eliminar Cupom",
                SURVEYS_SHOW: "Ver Pesquisas",
                SURVEYS_UPDATE: "Modificar Pesquisas",
                SURVEYS_CREATE: "Criar Pesquisas",
                SURVEYS_DELETE: "Eliminar Pesquisas",
                SURVEYS_MANAGEMENT: "Administrar Pesquisas",
                SURVEYS_RESPONSE_SHOW: "Ver respostas de Pesquisas",
                SURVEY_RESPONSES_MANAGEMENT: "Administrar respostas de Pesquisas",
                SURVEY_VIEW_CONFIG_UPDATE: "Modificar configuração de visualização de Pesquisas",
                QUANTITY_SALE: "Ver relatório de vendas por quantidade",
                AMOUNT_SALE: "Ver relatório de vendas por valor",
                REPORT_SALES: "Ver relatório de vendas",
                REPORT_ORDER: "Ver relatório de pedidos",
                REPORT_MENU: "Acessar menu de Relatórios",
                OPERATION_MENU: "Acessar menu de Operações",
                MANAGE_MENU: "Acessar menu de Administração",
                SALON_MENU: "Acessar menu de Salão"
            }
        }
    }
}

export default messages
